export default __webpack_public_path__ + "static/history-of-hiv-c83be25df46c6194e28d67a8395f34da.svg";